import Vue from 'vue'
import VueRouter from 'vue-router'
import { auth } from '../firebase'
import { isSessionValid } from '@/utils/common'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/leaders',
    name: 'admin',
    component: () => import('../views/Admin.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '*',
    name: 'not-found',
    meta: {
      requiresAuth: false,
      isNotFound: true
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  // Comment this "if" to test locally
  if (
    window.location.hostname != 'bd-kol.com' &&
    window.location.hostname != 'localhost'
  ) {
    window.location.href = 'https://bd-kol.com'
  }
  if (to.matched.some(record => record.meta.isNotFound)) {
    window.location = '/'
  }
  // CHeck for requiredAuth guard
  else if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if not logged in
    if (!auth.currentUser || !isSessionValid()) {
      if (auth.currentUser) {
        auth.signOut().then(() => {
          window.location = '/'
        })
      } else {
        window.location = '/'
      }
    } else {
      // Proceed to route
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Check if logged in
    if (auth.currentUser && isSessionValid()) {
      // Go to home
      next({
        name: 'admin',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Proceed to route
      next()
    }
  } else {
    // Proceed to route
    next()
  }
})

export default router
